import { Outlet } from "react-router-dom"
import { Header } from "layouts/Header.tsx"
import { Menu } from "layouts/Menu.tsx"
import { useRouteMatch } from "hooks/useRouteMatch.ts"
import { useEffect, useState } from "react"
import { SettingsMenu } from "layouts/SettingsMenu.tsx"
import Box from "@mui/material/Box"
import { Divider } from "@mui/material"
import { ProfilePageProvider } from "layouts/profile/context/provider.tsx"
import { OrganizationProvider } from "context/OrganizationContext.tsx"

export const Layout = () => {
    const inSettings = useRouteMatch(["/settings"]) 
    const [displayMenuSettings, setDisplayMenuSettings] = useState(false)

    useEffect(() => {
        setDisplayMenuSettings(!!inSettings)
    }, [inSettings])

    return (
        <Box sx={{ position: "relative" }} data-testid="global-layout">
            <OrganizationProvider>
                <ProfilePageProvider>
                    <Header />
                </ProfilePageProvider>

                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Box
                        sx={{
                            minHeight: "100vh",
                        }}
                    >
                        <SettingsMenu inSettings={displayMenuSettings} />
                    </Box>
                    <Box
                        sx={{
                            mt: "6rem",
                            mx: "1.5rem",
                            flex: 1,
                            zIndex: 1,
                            maxWidth: displayMenuSettings
                                ? "calc(100vw - 252px - 3rem)"
                                : "calc(100vw - 3rem)",
                        }}
                    >
                        <Menu />
                        <Divider />
                        <Box
                            sx={{
                                my: "1.5rem",
                                width: "100%",
                            }}
                        >
                            <Outlet />
                        </Box>
                    </Box>
                </Box>
            </OrganizationProvider>
        </Box>
    )
}
